<div appTheme>
    <form [formGroup]="registerForm" (ngSubmit)="onRegister(registerForm)">

        <div class="modal-box scrolling">
            <div class="modal-box" *ngIf="showPrivacyPolicy || showTerms">
                <div class="modal-box-container terms-and-privacy-container">
                    <div class="scrolling-terms-privacy">
                        <app-footer-privacy *ngIf="showPrivacyPolicy"></app-footer-privacy>
                        <app-footer-terms *ngIf="showTerms"></app-footer-terms>
                    </div>
                    <button class="submit-button ok-button" id="closeBtn"
                    (click)="showPrivacyPolicy ? togglePrivacyPolicy() : toggleTerms()">
                        Close
                    </button>
                </div>
            </div>
            <div class="col-xs-12 col-sm-10 col-md-8 col-lg-6 main-container">
                <div>
                    <h1>Your Business or Residence</h1>
                    <hr>
                    <div class="row">
                        <div class="col-sm-12">
                            <input
                                class="input-text"
                                type="text"
                                name="businessName"
                                formControlName="businessName"
                                required
                                maxlength="50"
                            />
                            <label>Business/Residence</label>

                            <span class="help-block"
                                  *ngIf="!registerFormControl.businessName.valid && registerFormControl.businessName.touched">Please enter a valid business/residence name.</span>

                            <input
                                class="input-text"
                                type="text"
                                name="address1"
                                formControlName="address1"
                                required
                                maxlength="50"
                            />
                            <label>Street address, P.O. box,c/o</label>

                            <span class="help-block" *ngIf="!registerFormControl.address1.valid && registerFormControl.address1.touched">Please enter a valid address.</span>

                            <input
                                class="input-text notReq"
                                type="text"
                                name="address2"
                                formControlName="address2"
                                maxlength="50"
                            />
                            <label *ngIf="!registerFormControl.address2.value">Apartment unit, building, floor etc.</label>

                            <input
                                class="input-text"
                                type="text"
                                name="city"
                                formControlName="city"
                                required
                                maxlength="50"
                            />
                            <label>City</label>

                            <span class="help-block" *ngIf="!registerFormControl.city.valid && registerFormControl.city.touched">Please enter a valid city.</span>

                            <div class="row">
                                <div class="col-sm-4">
                                    <input
                                        class="input-text input-width-100"
                                        type="text"
                                        name="zipCode"
                                        formControlName="zipCode"
                                        required
                                        (keypress)="onlyNumberKey($event)"
                                        maxlength="10"
                                    />
                                    <label>Zip Code</label>

                                    <span class="help-block" *ngIf="!registerFormControl.zipCode.valid && registerFormControl.zipCode.touched">Please enter a valid zipcode.</span>
                                </div>
                                <div class="col-sm-4 col-country-state">
                                    <select class="input-dropdown" formControlName="country" (change)="onCountryChanged($any($event.target.value))" name="country">
                                        <option [ngValue]="0" disabled selected hidden>Select Country</option>
                                        <option *ngFor="let c of countries" [ngValue]="c">{{c}}</option>
                                    </select>
                                </div>
                                <div class="col-sm-4 col-country-state" *ngIf="!showInputForState">
                                    <select class="input-dropdown" formControlName="state" name="state">
                                        <option [ngValue]="0" selected disabled hidden>Select State</option>
                                        <option *ngFor="let s of stateOrProvinces" [ngValue]="s">{{s}}</option>
                                    </select>
                                </div>
                                <div class="col-sm-4" *ngIf="showInputForState">
                                    <input
                                        type="text"
                                        class="input-text input-width-100"
                                        name="state"
                                        formControlName="state"
                                        required
                                        maxlength="50"
                                    />
                                    <label>State/Province</label>

                                    <span class="help-block" *ngIf="!registerFormControl.state.valid && registerFormControl.state.touched">Please enter a valid State.</span>
                                </div>
                            </div>

                            <input
                                class="input-text"
                                type="text"
                                name="phone"
                                [value]="registerFormControl.phone.value | PhoneNumber"
                                (ngModelChange)="onInputChange($event,'phoneLbl')"
                                formControlName="phone"
                                required
                                (keypress)="onlyNumberKey($event)"
                                maxlength="14"
                                pattern="^\(?([0-9]{3})\)?[-.\s]?([0-9]{3})[-.]?([0-9]{4})$"
                            />
                            <label id="phoneLbl">Phone</label>
                                <span class="help-block" *ngIf="!registerFormControl.phone.valid && registerFormControl.phone.touched">Please enter a valid phone number.</span>
                        </div>
                    </div>
                </div>
                <div class="about-yourself-section" >
                    <h1>About Yourself</h1>
                    <hr>
                    <div class="row">
                        <div class="col-sm-12">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <input
                                            class="input-text"
                                            type="text"
                                            name="firstName"
                                            formControlName="firstName"
                                            required
                                            maxlength="50"
                                        />
                                        <label>First Name</label>

                                        <span class="help-block" *ngIf="!registerFormControl.firstName.valid && registerFormControl.firstName.touched">Please enter a valid first name.</span>
                                    </div>
                                    <div class="col-sm-6">
                                        <input
                                            class="input-text"
                                            type="text"
                                            name="lastName"
                                            formControlName="lastName"
                                            required
                                            maxlength="50"
                                        />
                                        <label>Last Name</label>

                                        <span class="help-block" *ngIf="!registerFormControl.lastName.valid && registerFormControl.lastName.touched">Please enter a valid last name.</span>
                                    </div>
                                </div>

                                <input
                                    class="input-text"
                                    type="email"
                                    name="email"
                                    formControlName="email"
                                    required
                                    maxlength="50"
                                    pattern="[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}"
                                />
                                <label *ngIf="!registerFormControl.email.value">Email</label>

                                <span class="help-block" *ngIf="!registerFormControl.email.valid && registerFormControl.email.touched">Please enter a valid email address.</span>
                            <div class="row">
                                <div class="col-sm-6">
                                    <input
                                        class="input-text"
                                        type="password"
                                        name="password"
                                        formControlName="password"
                                        required
                                        maxlength="50"
                                        minlength="8"
                                    />
                                    <label *ngIf="!registerFormControl.password.value">Password</label>

                                    <span class="help-block" *ngIf="!registerFormControl.password.valid && registerFormControl.password.touched">{{this.passwordMsg}}</span>
                                </div>
                                <div class="col-sm-6">
                                    <input
                                        class="input-text"
                                        type="password"
                                        name="confirmPassword"
                                        formControlName="confirmPassword"
                                        required
                                        minlength="8"
                                        maxlength="50"
                                    />
                                    <label  *ngIf="!registerFormControl.confirmPassword.value">Confirm Password</label>

                                    <span class="help-block"
                                          *ngIf="registerFormControl.password.valid && !registerFormControl.confirmPassword.valid">Please enter a confirm password.</span>
                                    <span class="help-block"
                                          *ngIf="registerFormControl.confirmPassword.valid && registerFormControl.password.valid && registerFormControl.confirmPassword.value != registerFormControl.password.value">Passwords do not match.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br>
                <div class="terms-and-conditions">
                    <input
                        type="checkbox"
                        name="terms"
                        formControlName="terms"
                        required
                        class="input-checkbox"/>
                    <span class="checkbox-text"> I agree to the SMRTScape <a (click)="toggleTerms()">Terms of Service </a> and <a (click)="togglePrivacyPolicy()">Privacy Policy</a> .</span>
                </div>
                <p class="failure-message">{{error}}</p>
                <div class="bottom">
                    <button class="submit-button button-medium" id="signupBtn" [disabled]="!registerForm.valid">
                        Sign Up <i class="fa fa-arrow-right" aria-hidden="true"></i>
                    </button>
                    <button class="cancel-button button-small" id="cancelBtn" (click)="goToMain($event)">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>

<div *ngIf="isLoading" class="modal-box scrolling">
    <app-loading [text]="'Sending request to register user...'" [size]="'fa-5x'"></app-loading>
</div>

